import { createReducer } from 'deox';
import { EntitySummaries } from '@/types';
import { fetchSummaryActions, clearSummaryAction } from '@/redux/actions/service-directory/summary';

export interface SummaryState {
  entitySummaries?: EntitySummaries;
}

const initialState: SummaryState = {
  entitySummaries: undefined,
};

const serviceDirectorySocialReducer = createReducer(initialState, (handleAction) => [
  handleAction(fetchSummaryActions.success, (state, { payload }) => {
    return {
      ...state,
      entitySummaries: payload,
    };
  }),
  handleAction(clearSummaryAction.request, () => {
    return {
      entitySummaries: undefined,
    };
  }),
]);

export default serviceDirectorySocialReducer;
